import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { SummaryValue } from '../Cart/Summary/SummaryValue';
import { formatPriceToString } from '../../../utilities';
import { RequestStatus } from '../../Zemplin/MyAccount/RequestTitle';
import { RequestDetailItems } from './RequestDetailItems';
import { RequestTitle } from './RequestTitle';
import { getRequestDetailInfo } from '../selectors';

interface Props {
  data: any;
  isB2B: boolean;
}

function OrderDetail({ data, isB2B }: Props) {
  const {
    orderId,
    vs,
    ordernr,
    orderStatusReadable,
    items,
    totalPrice,
    totalPriceWithoutVat,
    currency,
    vat,
    yourNr,
    deliveryPrice,
    paymentPrice,
    deliveryName,
    paymentName,
  } = getRequestDetailInfo(data);

  return (
    <Wrapper>
      <RequestTitle
        title={`${__('Objednávka č.')} ${ordernr}`}
        smallText={''}
        statusText={orderStatusReadable}
        status={
          orderStatusReadable === 'Prijatá'
            ? RequestStatus.WAITING
            : orderStatusReadable === 'Spracováva sa' ||
              orderStatusReadable === 'Spracovávaná'
            ? RequestStatus.INWORK
            : RequestStatus.DONE
        }
      />
      <DeliveryInfoTitle>
        {`${__('Spôsob dopravy')}:`}
        <DeliveryInfo>{deliveryName}</DeliveryInfo>
      </DeliveryInfoTitle>
      <DeliveryInfoTitle>
        {`${__('Spôsob platby')}:`}
        <DeliveryInfo>{paymentName}</DeliveryInfo>
      </DeliveryInfoTitle>
      <RequestDetailItems items={items} hasMoreInfo={true} isB2B={isB2B} />
      <BottomWrapper>
        <SummaryValue
          title={__('Cena bez DPH')}
          value={formatPriceToString(totalPriceWithoutVat, currency)}
        />
        <SummaryValue
          title={__('DPH 20 %')}
          value={formatPriceToString(vat, currency)}
        />
        <SummaryValue
          title={__('Cena za dopravu s DPH')}
          value={formatPriceToString(deliveryPrice, currency)}
        />
        <SummaryValue
          title={__('Cena za platbu s DPH')}
          value={formatPriceToString(paymentPrice, currency)}
        />
        <SummaryValue
          title={__('Cena s DPH')}
          value={formatPriceToString(totalPrice, currency)}
        />
      </BottomWrapper>
    </Wrapper>
  );
}
const Wrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(1048)};
  margin-right: 0;
  margin-left: auto;

  ${({ theme }) => theme.mediab.l925`
    padding-top: ${rem(32)};
  `}
`;

const DeliveryInfoTitle = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${rem(12)};
  font-size: ${rem(14)};
  font-weight: 700;

  ${({ theme }) => theme.mediab.s450`
    margin-top: ${rem(16)}
  `}
`;

const DeliveryInfo = styled.span`
  font-weight: 400;
  margin-left: ${rem(8)};
`;

const BottomWrapper = styled(FlexCol)`
  margin-left: auto;
  margin-top: ${rem(8)};

  ${({ theme }) => theme.mediab.m810`
    margin: 0 auto;
    width: 100%;
  `}
`;

export { OrderDetail };
